import { FormattedMessage } from "react-intl";
import React, { Fragment } from "react";

const MainPresenterTextInfo = ({ content }) => {
  let mainPresenter = [];

  content.fieldAppearances.filter(Boolean).map((item) => {
    if (item.fieldMainPresenterOsRawField?.list?.length > 0) {
      mainPresenter.push(...item.fieldMainPresenterOsRawField.list);
    }
  });

  // Remove duplicates based on sponsor.targetId
  mainPresenter = mainPresenter.reduce((sponsor, current) => {
    const x = sponsor.find((item) => item.targetId === current.targetId);
    if (!x) {
      return sponsor.concat([current]);
    } else {
      return sponsor;
    }
  }, []);

  if (mainPresenter?.length > 0) {
    return (
      <div className="col-12 main-presenter-text-info">
        <div className={"text headline-subhead d-flex flex-wrap"}>
          <div className="label">
            <FormattedMessage id="presenter.main" />:{" "}
          </div>

          <div className={`values ${mainPresenter.length > 1 && "multiple"}`}>
            {mainPresenter.map((item, index) => (
              <Fragment key={item.targetId}>
                {item.entity.fieldWebsite ? (
                  <a href={item.entity.fieldWebsite.uri.path}>
                    {item.entity.title}
                    {mainPresenter[index + 1] && ", "}
                  </a>
                ) : (
                  <span>
                    {item.entity.title}
                  </span>
                )}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    );
  }
};

export default MainPresenterTextInfo;
